import axios from 'axios';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { OctResponse } from '../../models/OctResponse';
import { localStorageItem } from '../../utils/LocalStorage';
import { DatLichHenKhamParams, DatLichHenSearchParams } from '../models/DatLichHenModel';
import { APP_CONFIGURATION_KEYS } from '../../utils/Constant';

const BASE_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] ||
	process.env.REACT_APP_WMS_API_URL;

export const saveDatLichHen = async (params: DatLichHenKhamParams) => {
	const { data } = await axios.post<OctResponse<any>>(`${BASE_URL}/appointment`, params);
	return data;
};

export const updateDatLichHen = async (appointmentId: string, params: DatLichHenKhamParams) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/appointment/${appointmentId}`,
		params
	);
	return data;
};

export const printPhieuDatHen = async (params: any) => {
	return await axios.post<Blob>(`${BASE_URL}/medical-item-group/export`, params, {
		responseType: 'blob',
	});
};

export const printGiayHenKham = async (params: any) => {
	return await axios.post<Blob>(`${BASE_URL}/export/revisit-appointment`, params, {
		responseType: 'blob',
	});
};

export const getDanhSachDatLichHen = async (params: DatLichHenSearchParams) => {
	const response = await axios.get(`${BASE_URL}/appointment/search`, {
		params,
	});
	return response;
};

export const getThongTinBenhNhanDatLich = async (appointmentId: string) => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/admission/appointment/${appointmentId}`
	);
	return data;
};

export const getAppointmentByVisit = async (visitId: string) => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/appointment/last-visit/${visitId}`
	);
	return data;
};